<template>
    <div>
        
        
        <!-- tabla 3 -->
        
        <v-card>
            <v-card-text>
                <div class="table-box">
                    <table>
                        <thead>
                            <!-- fila de titulos -->
                            <tr>
                                <!-- titulos de columnas_inicio -->
                                <th v-for="columna in ajustes.columnas_inicio" :key="columna.key" :colspan="columna.colspan"  v-bind:class="{'header-0':columna.titulo_visible,'border':columna.titulo_visible}">{{columna.titulo}}</th>
                                <!-- titulos de columnas_inicio -->
                                
                                
                                <!-- generando el titulo por cada tipo de equipo -->
                                <th class="text-center" v-for="tipo in ajustes.tipos" :key="tipo.tipo_equipo_id" :colspan="tipo.colspan" v-bind:class="{'header-0':tipo.visible,'border':tipo.visible}">{{tipo.tipo_equipo}}</th>
                                <!-- generando el titulo por cada tipo de equipo -->

                                <!-- titulos de columnas_final -->
                                <th v-for="columna in ajustes.columnas_final" :key="columna.key" :colspan="columna.colspan"  v-bind:class="{'header-0':columna.titulo_visible,'border':columna.titulo_visible}">{{columna.titulo}}</th>
                                <!-- titulos de columnas_final -->

                            </tr>
                            <!-- fila de titulos -->

                            <!-- segunda fila de cabecera de equipos -->
                            <tr>

                                <!-- columnas_inicio -->
                                    <th :class="[{'hidden':columna.colspan == 0}]" :colspan="columna.colspan" :rowspan="columna.rowspan" v-for="columna in ajustes.columnas_inicio" :key="columna.key" class="text-center border header-1 z-index-header">
                                                    {{columna.cabecera}}
                                    </th>
                                <!-- columnas_inicio -->

                                <!-- equipos -->
                                <th :class="[{'hidden':columna.colspan == 0}]" :colspan="columna.colspan" v-for="columna in obtenerEquipos" :key="columna.key" class="text-center border header-1 z-index-header">
                                                    {{columna.cabecera}}
                                </th>
                                <!-- equipos -->

                                <!-- columnas_final -->
                                    <th :class="[{'hidden':columna.colspan == 0}]" :colspan="columna.colspan" :rowspan="columna.rowspan" v-for="columna in ajustes.columnas_final" :key="columna.key" class="text-center border header-1 z-index-header">
                                                    {{columna.cabecera}}
                                    </th>
                                <!-- columnas_final -->


                                <!-- header acciones -->
                                <!-- <th class="text-center border header-1 z-index-header" :colspan="settings2.actions.length">

                                </th> -->
                                <!-- header acciones -->

                            </tr>
                            <!-- segunda fila de cabecera de equipos -->


                            <!-- tercera fila de parámetros -->
                            <tr>
                                <!-- subcolumnas de columnas_inicio -->
                                    <th v-bind:class="{ 'hidden': !subcolumna.visible,'z-index-1':subcolumna.fixed == 1, 'z-index-2':subcolumna.fixed == 2,'z-index-3':subcolumna.fixed == 3,'z-index-header':subcolumna.fixed == 0}" v-for="subcolumna in obtenerSubColumnasInicio" :key="subcolumna.cabecera" class="text-center border header-2">
                                                {{subcolumna.cabecera}}
                                    </th>
                                <!-- subcolumnas de columnas_inicio -->


                                <!-- subcolumnas de parametros -->
                                <th v-bind:class="{ 'hidden': !parametro.visible,'z-index-1':parametro.fixed == 1, 'z-index-2':parametro.fixed == 2,'z-index-3':parametro.fixed == 3,'z-index-header':parametro.fixed == 0}" v-for="parametro in obtenerParametros" :key="parametro.id" class="text-center border header-2">
                                                <!-- <span v-if="sub_column.visible">
                                                    {{sub_column.header}}
                                                </span> -->
                                                {{parametro.nombre_parametro}}<br> ({{parametro.unidad_medida}})
                                </th>
                                <!-- subcolumnas de parametros -->

                                <!-- subcolumnas de columnas_final -->
                                    <th v-bind:class="{ 'hidden': !subcolumna.visible,'z-index-1':subcolumna.fixed == 1, 'z-index-2':subcolumna.fixed == 2,'z-index-3':subcolumna.fixed == 3,'z-index-header':subcolumna.fixed == 0}" v-for="subcolumna in obtenerSubColumnasFinal" :key="subcolumna.cabecera" class="text-center border header-2">
                                                {{subcolumna.cabecera}}
                                    </th>
                                <!-- subcolumnas de columnas_final -->

                                <!-- acciones -->
                                    <!-- <th class="text-center border header-2 z-index-header" v-for="action in ajustes.acciones" :key="action.key">
                                        <span v-if="action.visible">
                                            {{action.header}}
                                        </span>
                                    </th> -->
                                <!-- acciones -->
                            </tr>
                            <!-- tercera fila de parámetros -->
                        </thead>
                        <tbody id="miElemento">

                            <!-- registros -->
                            <tr v-for="registro in ultimos_registros" :key="registro.id" :class="`barridos-${registro.barrido == true  ? 1 : 0}`">

                                <!-- subcolumnas de columnas_inicio -->
                                
                                <td class="border text-center" v-bind:style="getColor(registro.color,null)" v-bind:class="{'fixed-left-1':subcolumna.fixed == 1,'fixed-left-2':subcolumna.fixed == 2,'fixed-left-3':subcolumna.fixed == 3}" v-for="subcolumna in obtenerSubColumnasInicio" :key="subcolumna.key" :style="subcolumna.cabecera=='MP' ? 'min-width: 200px;' : ''">
                                    
                                    <label>{{registro[subcolumna.key]}}</label>

                                    <!-- agregado para mostrar el detalle de un jumbo -->
                                    <v-tooltip top color="blue darken-4" v-if="subcolumna.key=='nro_jumbo' && registro.proviene_de!=null">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                            <v-icon color="blue darken-1">info</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{`Proviene de: ${registro.proviene_de.texto}`}}</span>
                                    </v-tooltip>
                                    <v-tooltip top color="orange darken-3" v-if="subcolumna.key=='nro_jumbo' && registro.movimiento!=null">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                            <v-icon color="orange darken-1">info</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{`Reproceso - Movimiento N° ${registro.movimiento} Fecha:  ${registro.movimiento_fecha}`}}</span>
                                    </v-tooltip>
                                    <!-- agregado para mostrar el detalle de un jumbo -->

                                    <!-- agregado para mostrar las observaciones -->
                                    <v-tooltip top color="orange darken-4" v-if="subcolumna.key=='hora' && registro.observacion != null && registro.observacion != ''">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon color="orange darken-1">insert_comment</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ registro.observacion }}</span>
                                    </v-tooltip>
                                    <!-- agregado para mostrar las observaciones -->

                                </td>                                
                                <!-- subcolumnas de columnas_inicio -->

                                <!-- parametros -->
                                <td style="white-space:nowrap;" :style="getColor(registro.color,null)" class="border text-center" v-for="parametro in obtenerParametros" :key="parametro.id">
                                    <label>{{registro[parametro.id].valor}}</label>
                                    <v-tooltip top color="orange darken-4" v-if="registro[parametro.id].observacion != null && registro[parametro.id].observacion != ''">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon color="orange darken-1">insert_comment</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ registro[parametro.id].observacion }}</span>
                                    </v-tooltip>

                                </td>
                                <!-- parametros -->

                                <!-- subcolumnas de columnas_final -->
                                <td v-bind:style="getColor(registro.color,subcolumna)" class="border text-center" v-bind:class="{'hidden': !subcolumna.visible,'fixed-left-1':subcolumna.fixed == 1,'fixed-left-2':subcolumna.fixed == 2,'fixed-left-3':subcolumna.fixed == 3}" v-for="subcolumna in obtenerSubColumnasFinal" :key="subcolumna.key" :style="['Analista', 'Muestreador','J. Turno'].includes(subcolumna.cabecera) ? 'min-width: 200px;' : ''">
                                    
                                    <label>{{registro[subcolumna.key]}}</label>
                                </td>
                                <!-- subcolumnas de columnas_final -->

                            </tr>
                            <!-- registros -->

                        </tbody>
                    </table>
                </div>
            </v-card-text>
        </v-card>
        <!-- tabla 3 -->

        <!-- modal para comentario de parametro -->
        <!-- modal para comentario de parametro -->
    </div>
</template>
<script>
// import axios from 'axios'
import {mapState,mapMutations} from 'vuex';

export default {
    props:['scroll_auto'],
    data:()=>({
        mostrar_alert:false,
        tipo_alert:'info',
        mensaje_alert:'',
        punto_medicion:'',
        punto_medicion_id:'',
        ajustes:{
            columnas_inicio:[],
            tipos:[],
            columnas_final:[],
        },
        registros:[],
        ultimos_registros:[],
        ultimos_registros_recibidos:[],
    }),
    beforeDestroy() {
        /**Elimina la subscripcion a los eventos cuando el componente tabla_registro es destruido */
        Event.$off('crear_tabla');
    },
    mounted() {
        this.$parent.$on('crear_tabla',(ajustes,ultimos_registros,punto_medicion)=>{
            this.registros = [];
            this.ultimos_registros = [];
            this.ultimos_registros_recibidos = [];
            this.punto_medicion = punto_medicion;

            this.ultimos_registros_recibidos = ultimos_registros;
            this.ajustes = ajustes;
            this.rellenarUltimosRegistros();

            // Realiza el scroll horizontal
            if(this.scroll_auto){
                this.scrollTable();
            }
            // console.log('ajustes_recibidos',this.ajustes);
            // console.log('ultimos_registros_recibidos',this.ultimos_registros_recibidos);
        });
    },
    // watch: {
    //     registros(newValue, oldValue) {
    //         // Realiza el scroll horizontal cada vez que se actualizan los registros
    //         this.scrollTable();
    //     },
    // },
    methods: {
        scrollTable() {
            const element = document.querySelector('.table-box');
            if (element) {
                const interval = setInterval(() => {
                    element.scrollBy({
                        left: 320,
                        behavior: 'smooth'
                    });

                    // Verifica si el scroll ha alcanzado el final
                    if (element.scrollLeft + element.clientWidth >= element.scrollWidth) {
                        clearInterval(interval); // Detiene el intervalo
                    }
                }, 1000*10); //10 seg
            }
        },
        async actualizar_comentario_analisis(registro){
            let registro_tabla = await this.buscarRegistroPorID(registro.id_registro);
            registro_tabla = registro;
        },
        async actualizar_comentario(registro){
            let registro_tabla = await this.buscarRegistroPorID(registro.id_registro);
            registro_tabla = registro;
        },
        getColor(color,subcolumna){
            // console.log('subcolumna',subcolumna);
            if(color!=null){
                if(subcolumna!=null){
                    if(subcolumna.key == 'fecha' || subcolumna.key == 'hora'){
                        return {};
                    }else{
                        return {
                            "background-color": color.valor,
                            "color":"#000000"
                        };
                    }
                }else{
                    return {
                        "background-color": color.valor,
                        "color":"#000000"
                    };
                }
            }
        },



        async calcularFormula(columna,registro){
            //console.log('pasos',columna.formula);
            //console.log('registro',registro);
            let resultado;
            await columna.formula.forEach(paso => {
                //por cada paso de la formula hago el calculo
                let num1,num2;
                //obteniendo el primer valor
                if(!isNaN(paso.primer_valor)){
                    //es un numero
                    num1 = paso.primer_valor;
                }else{
                    //es un valor que debo tomar del registro
                    if(paso.primer_valor == 'anterior'){
                        num1 = resultado;
                    }else{
                        num1 = registro[paso.key_1].valor;
                    }
                    //console.log('object',paso.key_1);
                }
                
                //obteniendo el segundo valor
                if(!isNaN(paso.segundo_valor)){
                    num2 = paso.segundo_valor;
                }else{
                    if(paso.segundo_valor == 'anterior'){
                        num2 = resultado;
                    }else{
                        num2 = registro[paso.key_2].valor;
                    }
                }

                if(paso.operador == '-'){
                    resultado = num1 - num2;
                }else if(paso.operador == '/'){
                    resultado = num1 / num2;
                }
            });
            registro[columna.id].valor = resultado.toFixed(2);
            //console.log('resultado',resultado.toFixed(2));
        },


        async rellenarUltimosRegistros(){
            //por cada registro hago un nuevo registro para agregarlo al array ultimos_registros
            await this.ultimos_registros_recibidos.forEach(async(reg) => {
                let registro = {
                    id_registro:reg.id
                };
                //agregando columnas de fecha y hora (materia prima si fuese linea)
                await this.obtenerSubColumnasInicio.forEach(sub=>{
                    registro[sub.key] = '';
                });
                //agregando columnas de analista, muestreador y jefe turno
                await this.obtenerSubColumnasFinal.forEach(sub=>{
                    registro[sub.key] = '';
                });
                //seteando la fecha y hora que viene del registro
                registro.fecha = this.moment(reg.fecha).format('DD-MM-YYYY');
                registro.hora = this.moment(reg.fecha).format('HH:mm');
                registro.tipo_mps_id = reg.tipo_mp?reg.tipo_mp.tipo_materia_prima:null;
                registro.analista = reg.analista?reg.analista.name:null;
                registro.muestreador = reg.muestreador?reg.muestreador.name:null;
                registro.jefe_turno = reg.jefe_turno?reg.jefe_turno.name:null;
                registro.color = reg.color;
                registro.lotes_id = reg.lote?reg.lote.nombre_lote:null;
                registro.barrido = reg.barrido?reg.barrido:null;
                registro.observacion = reg.observacion;


                //agregando control planta para el caso de los resultado análisis de los jumbos
                if(reg.control_planta_prefijo){
                    registro.control_planta = `${reg.control_planta_prefijo}${reg.control_planta_correlativo}`;
                    registro.proviene_de = null;
                    if(reg.jumbo!=null){
                        registro.nombre_lote = reg.jumbo.lote.nombre_lote;
                        registro.nro_jumbo = reg.jumbo.nro_jumbo;

                        if(reg.jumbo.viene_del_jumbo!=null){
                        console.log('entro al proviene de de ultimos registros',reg);
                            registro.proviene_de= {
                            lote:reg.jumbo.proveniente_de.lote.nombre_lote,
                            jumbo:reg.jumbo.proveniente_de.nro_jumbo,
                            texto:reg.jumbo.proveniente_de_texto};
                        }
                        registro.movimiento = null;
                        if(reg.jumbo.movimientos_id!=null){
                        // console.log('entro al movimiento del maxi',reg);
                            registro.movimiento = reg.jumbo.movimientos_id;
                            registro.movimiento_fecha = reg.jumbo.movimientos.fecha != null ? this.moment(reg.jumbo.movimientos.fecha).format('DD-MM-YYYY') : '';
                        }
                    }
                }
                
                //agregando los parametros del punto de medición
                await this.obtenerParametros.forEach(par => {
                    registro[par.id] = {
                        id:'',
                        resultado_analisis_id:'',
                        parametro_detalles_id:par.id,
                        nombre_parametro:par.nombre_parametro,
                        equipos_procesos_id:par.equipos_procesos_id,
                        nombre_equipo:par.nombre_equipo,
                        valor:'',
                        observacion:''
                    };
                });
                
                //asignando los valores de los registros de resultado_detalles
                await reg.resultado_detalles.forEach(detalle => {
                    // console.log('parametro_detalles_id',registro[detalle.parametro_detalles_id]);
                    // console.log('detalle',detalle.valor_real);
                    if(detalle.valor_real == 0){
                        detalle.valor_real = 'string';
                    }
                    //se cambió a esta forma para evitar el error cannot set id of undefined
                    registro[detalle.parametro_detalles_id] = {
                        id:detalle.id,
                        resultado_analisis_id:detalle.resultado_analisis_id,
                        parametro_detalles_id:detalle.parametro_detalles_id,
                        valor:isNaN(detalle.valor_real)?detalle.valor_real!='string'?detalle.valor_real:'':this.redondear(detalle.valor_real,1),
                        observacion:detalle.observacion,
                    };
                });

                this.ultimos_registros.push(registro);
            });

            console.log('ultimos registros ordenados',this.ultimos_registros);
        },

        redondear(value, precision) {
            var multiplier = Math.pow(10, precision || 0);
            // console.log(`numero redondeado: ${Math.round(value * multiplier) / multiplier}`);
            return Math.round(value * multiplier) / multiplier;
        },

        buscarRegistroPorID(id){
            let registro;
            registro = this.registros.find(reg=>{
                return reg.id_registro == id;
            });
            //buscando el registro entre los ultimos registros
            if(registro == undefined){
                registro = this.ultimos_registros.find(reg=>{
                    return reg.id_registro == id;
                });
            }
            //console.log('registro_encontrado',registro);
            return registro;
        },

        marcar_color_optimo(parametro,registro){
            /**recibe el parametro y el registro */
            
            let marcar = false;
            if(parametro.optimo_minimo && parametro.optimo_maximo){
                if(registro[parametro.id].valor >= parametro.optimo_minimo && registro[parametro.id].valor <= parametro.optimo_maximo){
                    marcar = true;
                    // console.log('parametro optimo',parametro);
                    // console.log('registro optimo',registro);
                }
            }
            return marcar;
        },

        marcar_alarma_minima(parametro,registro){
            return registro[parametro.id].valor < parametro.alarma_minimo && parametro.alarma_minimo!=null && registro[parametro.id].valor != ''? true : false;
        },
        marcar_alarma_maxima(parametro,registro){
            return registro[parametro.id].valor <= parametro.alarma_maximo && parametro.alarma_maximo!=null && registro[parametro.id].valor != '' && registro[parametro.id].valor >= parametro.alarma_minimo? true : false;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading']),
    },
    computed:{
        ...mapState(['base_url','headers']),
        
        obtenerSubColumnasInicio(){
            let subcolumnas_inicio = [];
            this.ajustes.columnas_inicio.forEach(columna=>{
                columna.subcolumnas.forEach(subcolumna => {
                    subcolumnas_inicio.push(subcolumna);
                });
            });
            //console.log('columnas_inicio',subcolumnas_inicio);
            return subcolumnas_inicio;
        },
        obtenerSubColumnasFinal(){
            let subcolumnas_final = [];
            this.ajustes.columnas_final.forEach(columna=>{
                columna.subcolumnas.forEach(subcolumna => {
                    subcolumnas_final.push(subcolumna);
                });
            });
            return subcolumnas_final;
        },
        obtenerEquipos(){
            let equipos = [];
            this.ajustes.tipos.forEach(tipo=>{
                tipo.equipos.forEach(equipo=>{
                    equipos.push(equipo);
                });
            });
            return equipos;
        },
        obtenerParametros(){
            let parametros = [];
            this.ajustes.tipos.forEach(tipo => {
                tipo.equipos.forEach(equipo=>{
                    equipo.parametros.forEach(par => {
                        parametros.push(par);
                    });
                });
            });
            return parametros;
        },
        numeroSubColumnas(){
            let num = 0;
            this.ajustes.tipos.forEach(tipo => {
                tipo.equipos.forEach(equipo=>{
                    equipo.parametros.forEach(par => {
                        num++;
                    });
                });
            });
            this.ajustes.columnas_final.forEach(columna=>{
                columna.subcolumnas.forEach(subcolumna => {
                    num++;
                });
            });
            this.ajustes.columnas_inicio.forEach(columna=>{
                columna.subcolumnas.forEach(subcolumna => {
                    num++;
                });
            });
            return num;
        }
    },
    components:{
        
    },
}
</script>
<style scoped>
.barridos-1{
    background-color: #b2dfdb;
}
.fila_separadora{
    height: 22px;
    background:#CFD8DC;
}
.border{
    border: 0.5px solid #333;
    border-collapse: collapse;
}
.hidden{
    display: none;
}

/* estilos de tabla */
.table-box{
    width: 100%;
    /*height: 430px;*/
    overflow: auto;
    border: 0.5px solid;
    /*box-shadow: 0 10px 100px rgba(0,0,0,0.5);*/
}

@media screen and (min-height: 481px)  {
  .table-box {
    height: 100%;
    height: calc(100vh - 200px) !important;
  }
}

@media screen and (max-height: 480px) {
  .table-box {
    height: 380px;
    height: calc(100vh - 120px) !important;
  }
}


table{
    border-spacing: 0px;
}
th{
    padding: 0px 0px;
    min-width: 100px;
    max-width: 100px;
    /*puse el height para indicar el alto de los th */
    height: 40px;
}
td{
    /* padding:1px 1px;
    margin: 0px; */
    height: 38px;
}

/*segunda fila de header*/
.z-index-1{
    left: 0px;
    z-index: 4;
}
.z-index-2{
    /*left: 150px;*/
    left:100px;
    z-index: 4;
}
.z-index-3{
    left: 300px;
    z-index: 4;
}
/*segunda fila de header*/

/* .z-index-action-1{
    z-index:1; 
    top: 0px;
}

.z-index-action-2{
    z-index:1; 
    top: 34px;
} */

.td_con_icono{
    min-width:120px !important;
    text-align: left !important;
}

thead th:first-child {
    left: 0;
    z-index: 4;
}
thead th.header-0{
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    padding: 0px 0px;
    background-color: #00796B;
    color: #fff;
    font-size: 1em;
    line-height: 1.3;
}

thead th.header-1{
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    padding: 0px 0px;
    background-color: #00796B;
    color: #fff;
    top: 0px;
    font-size: 1em;
    line-height: 1.3;
}

thead th.header-2{
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    padding: 0px 0px;
    background-color: #00796B;
    color: #fff;
    /*top: 34px;*/
    top:40px;
    font-size: 1em;
    line-height: 1.3;
}

/*capa mas baja del header de la tabla*/
.z-index-header{
    z-index: 1;
}



/*td columna 1, columna2, columna3*/
.fixed-left-1{
      left:0px;
      position: -webkit-sticky; /*for safary*/
      position:sticky;
      background-color: #00796B;
      color: #fff;
      z-index: 3;
}
.fixed-left-2{
      /*left:150px;*/
      left:100px;
      position: -webkit-sticky; /*for safary*/
      position:sticky;
      background-color: #00796B;
      color: #fff;
      z-index: 3;
}

.fixed-left-3{
      left:300px;
      position: -webkit-sticky; /*for safary*/
      position:sticky;
      background-color: #00796B;
      color: #fff;
      z-index: 3;
}

/*marcan una fila de color*/
.tr-red{
    background-color: rgba(244,67,54,0.65);
    color:#fff;
}
.tr-warning{
    background-color: rgba(255, 193, 7, 0.65);
    color:#333;
}

.tr-success{
 background: #7CB342;
 color:#fff
}

/*marcar una columna de color */
.limite_alto{
    background-color: rgba(244,67,54,0.65);
    color:#ffffff;
}
.limite_bajo{
    background-color: #F57F17;
    color: #ffffff;
}

/**colores para input de alarma,optimo minimo y máximo */
.color_optimo{
    background-color: #DCEDC8;
}
.alarma_minima{
    background-color: #BBDEFB;
}

.alarma_maxima{
    background-color: #EF9A9A;
}

input[type=number]{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 80px;
    padding: 2px 2px;
    margin-left: 0.5em;
    margin-right: 0.1em;
    border: 1.2px solid #212121;
}

input[type=text]{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 80px;
    padding: 2px 2px;
    border: 1.2px solid #212121;
}
select{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 120px;
    padding: 5px 5px;
}

input[type=datetime-local]{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: 120px;
    padding: 2px 2px;
}

input:focus{
    border: 1px solid #BBDEFB;
    border-radius: 3px;
}
</style>